
import { useEffect, useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { migrateDataToUser } from "@/lib/services/data-migration-service";
import { toast } from "sonner";

export function DataMigration() {
  const { user, isAuthenticated, loading } = useAuth();
  const [migrated, setMigrated] = useState(false);

  useEffect(() => {
    const handleMigration = async () => {
      if (!loading && isAuthenticated && user && !migrated) {
        try {
          await migrateDataToUser(user.id);
          setMigrated(true);
          toast.success("Your data has been synced to your account");
        } catch (error) {
          console.error("Migration error:", error);
          toast.error("Failed to sync your data");
        }
      }
    };

    handleMigration();
  }, [loading, isAuthenticated, user, migrated]);

  return null; // This is a utility component, no UI needed
}

export default DataMigration;
